(function () {
  'use strict';

  const d = document;
  const root = d.documentElement;
  const details = d.getElementById('Details-menu-drawer-container');
  const drawer  = d.getElementById('menu-drawer');
  const summary = d.querySelector('.header__icon--menu.header__icon--summary') || details?.querySelector('summary');
  const mq = matchMedia('(max-width: 989.98px)');
  if (!details || !drawer || !summary) return;

  // ───────── helpers ─────────
  const qsa = (sel, el = d) => Array.from(el.querySelectorAll(sel));
  const inModal = (evt) => !!evt.composedPath?.().find((n) => n?.getAttribute?.('aria-modal') === 'true');
  const selFocusable = 'a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])';
  const prefersReduced = matchMedia('(prefers-reduced-motion: reduce)').matches;

  // duration อ่านจาก CSS var (cache ครั้งเดียว)
  const cssDur = (() => {
    const v = getComputedStyle(root).getPropertyValue('--duration-default')?.trim() || '0.35s';
    const ms = v.endsWith('ms') ? parseFloat(v) : parseFloat(v) * 1000;
    return Math.max(50, Math.min(2000, ms));
  })();

  // safety-fallback transitionend → ไม่ค้างถ้า browser ดร็อปเฟรม
  function onceTransitionEnd(el, cb, fallback) {
    if (prefersReduced) { cb(); return; }
    let done = false;
    const finish = () => {
      if (done) return; done = true;
      el.removeEventListener('transitionend', h);
      clearTimeout(t); cb();
    };
    const h = (e) => { if (e.target === el) finish(); };
    el.addEventListener('transitionend', h);
    const t = setTimeout(finish, fallback || (cssDur + 80));
  }

  // ───────── state ─────────
  let lastFocus = null, locked = false, enabled = false, isAnimating = false;
  const overlay = details.querySelector('.menu-drawer__overlay');

  // ───────── header var (rAF-throttled) ─────────
  let headerRaf = 0;
  function syncHeaderVar() {
    if (headerRaf) return;
    headerRaf = requestAnimationFrame(() => {
      headerRaf = 0;
      const ann = d.querySelector('.pennello-announcement');
      if (ann && ann.classList.contains('pennello-announcement--hidden')) {
        const gtr = getComputedStyle(ann).gridTemplateRows;
        if (gtr !== '0px' && gtr !== 'none') return; // กำลังขยับอยู่ — รอ
      }
      const hdr = d.querySelector('.shopify-section-header, .header-wrapper');
      const h = hdr ? Math.max(0, Math.round(hdr.getBoundingClientRect().height)) : 60;
      root.style.setProperty('--pnl-header-h', h + 'px');
    });
  }

  // ───────── scroll lock ─────────
  function lockScroll(on) {
    if (on && !locked) {
      const y = window.scrollY || 0;
      root.dataset.pnlScrollY = String(y);
      const sbw = window.innerWidth - root.clientWidth;
      if (sbw > 0) root.style.setProperty('--pnl-pr', sbw + 'px');
      // เขียนรอบเดียว ลด layout thrash
      root.style.cssText += `;position:fixed;top:-${y}px;left:0;right:0;width:100%;padding-right:var(--pnl-pr,0px);`;
      root.classList.add('pnl-no-scroll', 'pnl-drawer-open');
      locked = true;
    } else if (!on && locked) {
      const y = Number(root.dataset.pnlScrollY || 0);
      root.classList.remove('pnl-no-scroll', 'pnl-drawer-open');
      root.style.position = '';
      root.style.top = '';
      root.style.left = '';
      root.style.right = '';
      root.style.width = '';
      root.style.paddingRight = '';
      root.style.removeProperty('--pnl-pr');
      delete root.dataset.pnlScrollY;
      locked = false;
      // คืนค่าทันทีในเฟรมเดียวกัน เพื่อไม่ให้เห็นกระโดด
      window.scrollTo(0, y);
    }
  }

  const firstFocusable = () => drawer.querySelector(selFocusable);

  // ───────── will-change hint (เปิดเฉพาะตอนเล่นแอนิเมชัน) ─────────
  function primeWillChange(on) {
    const v = on ? 'transform, opacity' : '';
    drawer.style.willChange = v;
    if (overlay) overlay.style.willChange = on ? 'opacity' : '';
  }

  // ───────── focus trap ─────────
  function focusTrap(e) {
    if (!details.open || e.key !== 'Tab') return;
    const f = qsa(selFocusable, drawer);
    if (!f.length) return;
    const first = f[0], last = f[f.length - 1];
    if (e.shiftKey && d.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && d.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  // ───────── submenu close (smooth, ใช้ transitionend) ─────────
  function closeSubmenu(det) {
    if (!det || !det.open) return;
    const submenu = det.querySelector('.menu-drawer__submenu');
    det.classList.add('leaving');
    if (submenu) submenu.classList.add('is-leaving');

    const cleanup = () => {
      det.open = false;
      det.classList.remove('leaving');
      if (submenu) submenu.classList.remove('is-leaving');
    };
    if (submenu) onceTransitionEnd(submenu, cleanup);
    else setTimeout(cleanup, cssDur);
  }

  // ───────── open ─────────
  function openDrawer() {
    if (details.open || isAnimating) return;
    isAnimating = true;
    syncHeaderVar();
    lastFocus = d.activeElement;
    primeWillChange(true);

    // เปิดในเฟรมถัดไป เพื่อให้ browser commit will-change ก่อน
    requestAnimationFrame(() => {
      details.open = true;
      summary.setAttribute('aria-expanded', 'true');
      lockScroll(true);

      // รอ transition จริงจบ → ค่อย focus + ปล่อย will-change
      onceTransitionEnd(drawer, () => {
        primeWillChange(false);
        isAnimating = false;
        firstFocusable()?.focus?.();
      });
    });
  }

  // ───────── close ─────────
  function closeDrawer() {
    if (!details.open) return Promise.resolve();
    if (isAnimating) {
      // ถ้ากำลังเปิดอยู่ แล้วผู้ใช้สั่งปิด ให้รอจบก่อนแล้วค่อยปิด
      return new Promise((res) => {
        const tick = () => isAnimating ? requestAnimationFrame(tick) : res(closeDrawer());
        tick();
      });
    }
    isAnimating = true;
    summary.setAttribute('aria-expanded', 'false');
    primeWillChange(true);

    // ปิด submenu ที่เปิดอยู่ก่อน (สมูทพร้อม drawer)
    qsa('details[open]', drawer).forEach(closeSubmenu);

    return new Promise((resolve) => {
      // ใส่ class ในเฟรมถัดไปเพื่อให้ transition เริ่มลื่น
      requestAnimationFrame(() => {
        details.classList.add('is-closing');

        onceTransitionEnd(drawer, () => {
          details.open = false;
          details.classList.remove('is-closing');
          lockScroll(false);
          primeWillChange(false);
          isAnimating = false;
          if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
          resolve();
        });
      });
    });
  }

  // ───────── summary (hamburger) ─────────
  const onSummaryClick = (e) => {
    if (!mq.matches) return;
    e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
    details.open ? closeDrawer() : openDrawer();
  };
  const onSummaryKey = (e) => {
    if (!mq.matches) return;
    if (e.code === 'Space' || e.key === 'Enter') {
      e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
      details.open ? closeDrawer() : openDrawer();
    }
  };

  // ───────── drawer delegate ─────────
  const onDrawerClick = (e) => {
    if (!mq.matches) return;
    const t = e.target;

    // back-button
    const backBtn = t.closest('.menu-drawer__back-button');
    if (backBtn) {
      e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
      closeSubmenu(backBtn.closest('details[open]'));
      return;
    }

    // internal link → ปิดแล้วค่อยนำทาง (ลื่นกว่า)
    const a = t.closest('a[href]');
    if (a && a.origin === location.origin && !a.hasAttribute('target') && !a.hasAttribute('download')) {
      const href = a.href;
      e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
      // นำทางทันทีหลัง animation จบจริง — ไม่ใช้ delay ตายตัว
      closeDrawer().then(() => { location.href = href; });
    }
  };

  const onDrawerKey = (e) => {
    if (!mq.matches) return;
    if (e.key !== 'Enter' && e.code !== 'Space') return;
    const btn = e.target.closest('.menu-drawer__back-button');
    if (!btn) return;
    e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
    closeSubmenu(btn.closest('details[open]'));
  };

  // ───────── overlay / doc ─────────
  const onOverlayClick = (e) => { if (!mq.matches) return; e.preventDefault(); closeDrawer(); };
  const onDocClick = (e) => {
    if (!mq.matches || !details.open) return;
    if (inModal(e)) return;
    if (e.target.closest('summary') === summary) return;
    if (!drawer.contains(e.target)) closeDrawer();
  };
  const onDocKey = (e) => { if (!mq.matches) return; if (e.key === 'Escape') closeDrawer(); else focusTrap(e); };

  // resize → throttle ด้วย rAF
  let resizeRaf = 0;
  const onResize = () => {
    if (resizeRaf) return;
    resizeRaf = requestAnimationFrame(() => { resizeRaf = 0; syncHeaderVar(); });
  };

  // ───────── enable / disable ─────────
  function enable() {
    if (enabled) return; enabled = true;
    summary.addEventListener('click', onSummaryClick, true);
    summary.addEventListener('keydown', onSummaryKey, true);
    drawer.addEventListener('click', onDrawerClick, true);
    drawer.addEventListener('keydown', onDrawerKey, true);
    overlay?.addEventListener('click', onOverlayClick);
    d.addEventListener('click', onDocClick);
    d.addEventListener('keydown', onDocKey);
    window.addEventListener('load', onResize, { passive: true });
    window.addEventListener('resize', onResize, { passive: true });
    window.addEventListener('orientationchange', onResize, { passive: true });
    d.addEventListener('shopify:section:load', syncHeaderVar);
  drawer.setAttribute('role', 'dialog');
    drawer.setAttribute('aria-modal', 'true');
    if (!drawer.hasAttribute('aria-label') && !drawer.hasAttribute('aria-labelledby')) {
      drawer.setAttribute('aria-label', 'เมนูนำทาง');
    }
    syncHeaderVar();
  }
  function disable() {
    if (!enabled) return; enabled = false;
    if (details.open) closeDrawer();
    summary.removeEventListener('click', onSummaryClick, true);
    summary.removeEventListener('keydown', onSummaryKey, true);
    drawer.removeEventListener('click', onDrawerClick, true);
    drawer.removeEventListener('keydown', onDrawerKey, true);
    overlay?.removeEventListener('click', onOverlayClick);
    d.removeEventListener('click', onDocClick);
    d.removeEventListener('keydown', onDocKey);
    window.removeEventListener('load', onResize);
    window.removeEventListener('resize', onResize);
    window.removeEventListener('orientationchange', onResize);
    d.removeEventListener('shopify:section:load', syncHeaderVar);
    drawer.removeAttribute('role');
    drawer.removeAttribute('aria-modal');
    drawer.removeAttribute('aria-label');
  }

  const mqHandler = (e) => (e.matches ? enable() : disable());
  if (mq.addEventListener) mq.addEventListener('change', mqHandler);
  else mq.addListener(mqHandler);
  mqHandler(mq);

  // reduced motion
  if (prefersReduced) {
    drawer.style.transition = 'none';
    qsa('.menu-drawer__submenu', drawer).forEach((el) => (el.style.transition = 'none'));
    if (overlay) overlay.style.transition = 'none';
  }
})();